import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { beep } from "./beep.js"
import ErrorPopup from "./ErrorPopup.js"
import { EDIT_USER_URL } from "./Constants.js"
import {
    cap_Name,
    valid_Email,
    valid_Name,
    valid_PhoneNumber,
} from "./Validate"

const UserEdit = () => {
	const { state } = useLocation() // access state from calling route
	const { user } = state // set the state into the user object
	const navigate = useNavigate()

	const [status, setStatus] = useState("")
	const [error, setError] = useState("")
	const [answerUserId, setAnswerUserId] = useState()
	const [answerLastname, setAnswerLastname] = useState("")
	const [answerFirstname, setAnswerFirstname] = useState("")
	const [answerEmail, setAnswerEmail] = useState("")
	const [answerPhone, setAnswerPhone] = useState("")
	const [answerStatus, setAnswerStatus] = useState("")
	const [LN_bgc, setLN_bgc] = useState()
	const [FN_bgc, setFN_bgc] = useState()
	const [EM_bgc, setEM_bgc] = useState()
	const [PN_bgc, setPN_bgc] = useState()
	const [LN_Valid, setLN_Valid] = useState(true)
	const [FN_Valid, setFN_Valid] = useState(true)
	const [EM_Valid, setEM_Valid] = useState(true)
	const [PN_Valid, setPN_Valid] = useState(true)

	// easy-peasy
	const setHeaderCity = useStoreActions((actions) => actions.setHeaderCity)
	const setHeaderUser = useStoreActions((actions) => actions.setHeaderUser)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const LoggedIn = useStoreState((state) => state.LoggedIn)
	const Token = useStoreState((state) => state.Token)

	useEffect(() => { if (error) beep() }, [error])

	useEffect(() => {
		setAnswerUserId(user[0])
		setAnswerLastname(user[1])
		setAnswerFirstname(user[2])
		setAnswerEmail(user[3])
		setAnswerPhone(user[4])
		setAnswerStatus(user[5])
	}, [])

	const handleLastnameChange = (e) => {
		setAnswerLastname(cap_Name(e.target.value))
		if (valid_Name(e.target.value)) {
			setLN_bgc({})
			setLN_Valid(true)
		} else {
			setLN_bgc({ backgroundColor: "pink" })
			setLN_Valid(false)
		}
		setError("")
	}

	const handleFirstnameChange = (e) => {
		setAnswerFirstname(cap_Name(e.target.value))
		if (valid_Name(e.target.value)) {
			setFN_bgc({})
			setFN_Valid(true)
		} else {
			setFN_bgc({ backgroundColor: "pink" })
			setFN_Valid(false)
		}
		setError("")
	}

	const handleEmailChange = (e) => {
		const v = e.target.value.toLowerCase()
		setAnswerEmail(v)
		if (valid_Email(v)) {
			setEM_bgc({})
			setEM_Valid(true)
		} else {
			if (v.length === 0) {
				setEM_bgc({})
			} else {
				setEM_bgc({ boxShadow: "0 0 0 4px red" })
			}
			setEM_Valid(false)
		}
		setError("")
	}

	const handlePhoneChange = (e) => {
		// Validate limited to North American phone format
		const isDeleting = e.target.value.length < answerPhone.length
		let result = valid_PhoneNumber(e.target.value, isDeleting)
		// Result array positions
		// 0 = isValid boolean
		// 1 = errMsg
		// 2 = phoneno string

		// Set the phoneno to be displayed
		setAnswerPhone(result[2])
		// setPN_Help(result[1])

		if (result[0]) {
			setPN_bgc({})
			setPN_Valid(true)
		} else {
			setPN_bgc({ boxShadow: "0 0 0 4px red" })
			setPN_Valid(false)
		}
		setError("")
	}

	// An option of Pending is set for a new user until email is verified
	const options = ["Active", "Suspended"]
	const onOptionChangeHandler = (event) => {
		setAnswerStatus(event.target.value)
	}

async function handleEdit(e) {
		e.preventDefault()
		let sts = ""

		try {
			const request = {
				login_id: Token.login_id,
				client_id: Token.client_id,
				expires: Token.expires,
				form_id: answerUserId,
				form_lastname: answerLastname,
				form_firstname: answerFirstname,
				form_email: answerEmail,
				form_phone: answerPhone,
				form_status: answerStatus,
			}
			const { data } = await axios.put(EDIT_USER_URL, request)

			let txt = data.msg
			// The api msg is either Success or ERROR: Duplicate email or phone
			if (txt.slice(0, 5) === "ERROR") {
				sts = "duplicate"
				setError(data.msg)
			} else {
				// The user was updated
				sts = "success"
			}
			if (sts === "success" || sts === "duplicate") {
				setError("")
			}
			setStatus(sts)
		} catch (err) {
			setError(err.message)
			if (err.message === "Request failed with status code 401") {
				setError("Timeout")
			}
			// Code 422 indicates user tried to refresh page
			// React does not handle page refreshes so trigger a new login
			if (err.message === "Request failed with status code 422") {
				setError("422")
			}
			if (err.message === "Request failed with status code 500") {
				setError("500")
			}
		}

		setTimeout(() => {
			// remove the message line
			if (error) {
				// 422 condition or some other error
				setHeaderCity("CR Cloud Technology")
				setHeaderUser("None")
				setLoggedIn(false)
				navigate("/login")
			} else {
				// Successful edit so return to user screen
				setError("")
				setStatus("")
				navigate("/user")
			}
		}, 3000)
	}

	return (
		<main className="Main">
			<fieldset className="panel-sm">
				<legend>Edit User</legend>
				<form className="InputForm" name="InputForm" onSubmit={handleEdit}>
					<table id="tbl_box" style={{ border: "none" }}>
						<tbody>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userLastname">Lastname:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<input
										name="userLastname"
										id="userLastname"
										type="text"
										required
										onChange={(e) => handleLastnameChange(e)}
										value={answerLastname}
										style={LN_bgc}
									/>
								</td>
							</tr>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userFirstname">Firstname:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<input
										name="userFirstname"
										id="userFirstname"
										type="text"
										required
										value={answerFirstname}
										style={FN_bgc}
										onChange={(e) => handleFirstnameChange(e)}
									/>
								</td>
							</tr>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userEmail">Email:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<input
										name="userEmail"
										id="userEmail"
										type="text"
										required
										value={answerEmail}
										style={EM_bgc}
										onChange={(e) => handleEmailChange(e)}
									/>
								</td>
							</tr>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userPhone">Mobile Phone:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<input
										name="userPhone"
										id="userPhone"
										type="text"
										value={answerPhone}
										style={PN_bgc}
										onChange={(e) => handlePhoneChange(e)}
									/>
								</td>
							</tr>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userStatus">Status:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<select
										id="userStatus"
										value={answerStatus}
										onChange={onOptionChangeHandler}
									>
										{options.map((option, index) => {
											return <option key={index}>{option}</option>
										})}
									</select>
								</td>
							</tr>
						</tbody>
					</table>
					<div className="InputItem" style={{ textAlign: "center" }}>
						<button
							className="saveBtn"
							type="submit"
							style={{ display: "inline-block" }}
							disabled={
								!LN_Valid ||
								!FN_Valid ||
								!EM_Valid ||
								!PN_Valid ||
								Token.city_id === 0 ||
								status === "submitting"
							}
						>
							Save
						</button>
						<button
							className="saveBtn"
							type="button"
							style={{ display: "inline-block", marginLeft: "0.5rem" }}
							onClick={() => navigate("/user")}
						>
							List
						</button>
						<ErrorPopup message={error ? `Edit failed — ${error}` : ""} onClose={() => setError("")} />
						{status === "success" && <p id="successMsg">User Updated!</p>}
					</div>
				</form>
			</fieldset>
		</main>
	)
}

export default UserEdit
